(function (window, document, $, undefined) {
    var $cultureLinks = $('.dropdown-item--language-switch');
    $cultureLinks.on("click", function cultureLinkClick(event) {
        event.preventDefault();

        const expires = new Date();
        expires.setFullYear(expires.getFullYear() + 1);

        document.cookie 
            = `preferredCulture=${$(this).attr('hreflang')};`
            + 'path=/;'
            + `expires=${expires.toUTCString()};`
            + 'SameSite=Lax;'
            + 'Secure';

        window.location.href = $(this).attr('href');
    });
})(window, document, jQuery);
